import React, { useEffect, useState } from "react";
import { convertToRefString } from "./services/convertToRefString";
import CiteNumber from "./CiteNumber";
import CiteSource from "./CiteSource";
import HtmlStringRenderer from "./HtmlStringRenderer";
import CiteMultipleSource from "./CiteMultipleSource";

const componentMap = {
  "editor-highlight-number": {
    component: CiteNumber,
    propsMap: {
      originalnumvalue: "originalNumValue",
      numvalue: "numValue",
      qid: "qid",
    },
  },
  "numeric-citation": {
    component: CiteNumber,
    propsMap: {
      originalnumvalue: "originalNumValue",
      numvalue: "numValue",
      qid: "qid",
    },
  },
  "cite-number": {
    component: CiteNumber,
    propsMap: {
      originalnumvalue: "originalNumValue",
      numvalue: "numValue",
      qid: "qid",
    },
  },
  citation: {
    component: CiteSource,
    propsMap: {
      id: "id",
      qid: "qid",
    },
  },
  "cite-source": {
    component: CiteSource,
    propsMap: {
      id: "id",
      qid: "qid",
    },
  },
  "multiple-citations": {
    component: CiteMultipleSource,
    propsMap: {
      qid: "qid",
      citationString: "citationString",
    },
  },
  multipleCitations: {
    component: CiteMultipleSource,
    propsMap: {
      qid: "qid",
      citationString: "citationString",
    },
  },
};

const ReferenceWrapper = ({
  text = "",
  sourceMap = {},
  qid = "",
}: {
  text: string;
  sourceMap: any;
  qid: string;
}) => {
  const [processedText, setProcessedText] = useState("");

  useEffect(() => {
    setProcessedText(convertToRefString({ htmlString: text, sourceMap, qid }));
    // console.log(text, "=>", processedText);
  }, [text]);

  return (
    <span onClick={() => console.log(processedText, sourceMap, qid)}>
      <HtmlStringRenderer
        htmlString={processedText}
        componentMap={componentMap}
      />
    </span>
  );
};

export default ReferenceWrapper;
